import * as actions from "./actionTypes/index";

export const AsianGamesListUpdateReceived = (payload, key) => {
    return {
        type: actions.ASIAN_GAMES_LIST_UPDATE_RECEIVED,
        key,
        payload
    };
};

export const ResetAsianGamesList = (key) => {
    return {
        type: actions.RESET_ASIAN_GAMES_LIST,
        key
    };
};
export const ToggleListByDate = () => {
    return {
        type: actions.ASIAN_GAMES_TOGGLE_DATE_SORT,
        payload: {}
    };
};